











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReflectionGroupVoting_reflectionGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerVoteCount",
      "storageKey": null
    }
  ],
  "type": "RetroReflectionGroup",
  "abstractKey": null
};

(node ).hash = "056bdd8f0a84743124bdfddbf1d136d1";

export default node;
